import React, { useEffect, useState, useRef, } from 'react';
import './cart.css';
import { useSelector, useDispatch } from 'react-redux';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { BsPlus } from "react-icons/bs";
import { BiMinus } from 'react-icons/bi';
import api from '../../api/api';
import { toast } from 'react-toastify';
import EmptyCart from '../../utils/zero-state-screens/Empty_Cart.svg';
import { Link, useNavigate } from 'react-router-dom';
import Loader from '../loader/Loader';
import { useTranslation } from 'react-i18next';
import { setProductSizes } from "../../model/reducer/productSizesReducer";
import { addtoGuestCart, clearCartPromo, setCart, setCartProducts, setCartSubTotal, setGuestCartTotal } from "../../model/reducer/cartReducer";
import Promo from "./Promo";
import { RiCoupon2Fill } from 'react-icons/ri';
import Login from '../login/Login';
import { setPromoCode } from '../../model/reducer/promoReducer';



const Cart = ({ isCartSidebarOpen, setIsCartSidebarOpen }) => {

    const closeCanvas = useRef();
    const dispatch = useDispatch();
    const navigate = useNavigate();


    const cart = useSelector(state => (state.cart));
    const user = useSelector(state => (state.user));
    const city = useSelector(state => (state.city));
    const sizes = useSelector(state => (state.productSizes));
    const setting = useSelector(state => (state.setting));

    const [productSizes, setproductSizes] = useState(null);
    const [iscartEmpty, setiscartEmpty] = useState(false);
    const [isLoader, setisLoader] = useState(false);
    const [showPromoOffcanvas, setShowPromoOffcanvas] = useState(false);
    const [cartSidebarData, setCartSidebarData] = useState([]);
    const [guestCartSubTotal, setGuestCartSubTotal] = useState(null);
    const [showModal, setShowModal] = useState(false);
    // const [cartSubTotal, setCartSubTotal] = useState(0);
    // console.log("Cart SideBar Open State ->", isCartSidebarOpen);
    useEffect(() => {
        if (sizes.sizes === null || sizes.status === 'loading') {
            if (city.city !== null && cart.cart !== null) {
                api.getProductbyFilter(city.city.latitude, city.city.longitude)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === 1) {
                            setproductSizes(result.sizes);
                            dispatch(setProductSizes({ data: result.sizes }));
                        }
                    });
            }
        }
        else {
            setproductSizes(sizes.sizes);
        }



        if ((cart.cart === null && cart.status === 'fulfill') || cart.status === 1) {
            setiscartEmpty(true);
        }
        else {
            setiscartEmpty(false);
        }

    }, [cart]);



    useEffect(() => {
        if (cart?.cart) {
            dispatch(clearCartPromo());
        }
        if (isCartSidebarOpen === true && cart?.isGuest === false) {
            fetchCartData();
        } else if (isCartSidebarOpen === true && cart?.isGuest === true && cart?.guestCart?.length !== 0) {
            fetchGuestCart();
        } else if (isCartSidebarOpen === true && cart?.isGuest === true && cart?.guestCart?.length === 0) {
            // إذا كانت السلة فارغة، تأكد من تعيين المجموع الكلي إلى 0
            setCartSidebarData([]);
            setGuestCartSubTotal(0);
            dispatch(setGuestCartTotal({ data: 0 }));
        }
        if (cart?.isGuest === true && cart?.guestCart?.length === 0) {
            setCartSidebarData([]);
            setGuestCartSubTotal(0);
            dispatch(setGuestCartTotal({ data: 0 }));
        }
        const handleClickOutside = (event) => {
            if (isCartSidebarOpen &&
                !event.target.closest('.cart-sidebar-container') &&
                !event.target.closest(".Toastify__toast-container") &&
                !event.target.closest(".promo-sidebar-container")) {
                handleCloseCartSidebar(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isCartSidebarOpen]);

    // مراقبة التغييرات في guestCartTotal من Redux
    useEffect(() => {
        if (cart?.isGuest && cart?.guestCartTotal !== undefined) {
            setGuestCartSubTotal(cart.guestCartTotal);
        }
    }, [cart?.guestCartTotal, cart?.isGuest]);


    const fetchCartData = async () => {
        setisLoader(true);
        try {
            const response = await api.getCart(user?.jwtToken, city?.city?.latitude, city?.city?.longitude);
            const result = await response.json();
            if (result.status == 1) {
                const productsData = result?.data?.cart?.map((product) => {
                    // البحث عن المنتج في البيانات المحلية للحصول على اللون والمقاس المحددين
                    // نبحث أولاً باللون والمقاس إذا كان متوفراً
                    let existingLocal = null;
                    if (product?.selected_color || product?.selected_size) {
                        existingLocal = cart?.cartProducts?.find(p => 
                            p.product_variant_id === product?.product_variant_id &&
                            p.product_id === product?.product_id &&
                            p.selected_color === product?.selected_color &&
                            p.selected_size === product?.selected_size
                        );
                    }
                    
                    // إذا لم نجد، نبحث بدون اللون والمقاس
                    if (!existingLocal) {
                        existingLocal = cart?.cartProducts?.find(p => 
                            p.product_variant_id === product?.product_variant_id &&
                            p.product_id === product?.product_id
                        );
                    }
                    
                    // إذا لم نجد في البيانات المحلية، نحاول استخراج من البيانات التي تأتي من API
                    let selectedColor = existingLocal?.selected_color || product?.selected_color || null;
                    let selectedSize = existingLocal?.selected_size || product?.selected_size || null;
                    
                    // إذا لم تكن هناك بيانات محددة، نحاول استخراج من colors و size
                    if (!selectedColor && product?.colors) {
                        try {
                            const colors = JSON.parse(product.colors);
                            if (Array.isArray(colors) && colors.length > 0) {
                                selectedColor = colors[0]; // نأخذ أول لون كافتراضي
                            }
                        } catch (error) {
                            console.error('Error parsing colors:', error);
                        }
                    }
                    
                    if (!selectedSize && product?.size) {
                        try {
                            const sizes = JSON.parse(product.size);
                            if (Array.isArray(sizes) && sizes.length > 0) {
                                selectedSize = sizes[0]; // نأخذ أول مقاس كافتراضي
                            }
                        } catch (error) {
                            console.error('Error parsing sizes:', error);
                        }
                    }
                    
                    return {
                        product_id: product?.product_id,
                        product_variant_id: product?.product_variant_id,
                        qty: product?.qty,
                        selected_color: selectedColor,
                        selected_size: selectedSize
                    };
                });

                // also enrich cart items in sidebar for immediate use
                const enrichedCart = result?.data?.cart?.map(item => {
                    // البحث عن المنتج في البيانات المحلية للحصول على اللون والمقاس المحددين
                    // نبحث أولاً باللون والمقاس إذا كان متوفراً
                    let existingLocal = null;
                    if (item?.selected_color || item?.selected_size) {
                        existingLocal = cart?.cartProducts?.find(p => 
                            p.product_variant_id === item?.product_variant_id &&
                            p.product_id === item?.product_id &&
                            p.selected_color === item?.selected_color &&
                            p.selected_size === item?.selected_size
                        );
                    }
                    
                    // إذا لم نجد، نبحث بدون اللون والمقاس
                    if (!existingLocal) {
                        existingLocal = cart?.cartProducts?.find(p => 
                            p.product_variant_id === item?.product_variant_id &&
                            p.product_id === item?.product_id
                        );
                    }
                    
                    // إذا لم نجد في البيانات المحلية، نحاول استخراج من البيانات التي تأتي من API
                    let selectedColor = existingLocal?.selected_color || item?.selected_color || null;
                    let selectedSize = existingLocal?.selected_size || item?.selected_size || null;
                    
                    // إذا لم تكن هناك بيانات محددة، نحاول استخراج من colors و size
                    if (!selectedColor && item?.colors) {
                        try {
                            const colors = JSON.parse(item.colors);
                            if (Array.isArray(colors) && colors.length > 0) {
                                selectedColor = colors[0]; // نأخذ أول لون كافتراضي
                            }
                        } catch (error) {
                            console.error('Error parsing colors:', error);
                        }
                    }
                    
                    if (!selectedSize && item?.size) {
                        try {
                            const sizes = JSON.parse(item.size);
                            if (Array.isArray(sizes) && sizes.length > 0) {
                                selectedSize = sizes[0]; // نأخذ أول مقاس كافتراضي
                            }
                        } catch (error) {
                            console.error('Error parsing sizes:', error);
                        }
                    }
                    
                    return {
                        ...item,
                        selected_color: selectedColor,
                        selected_size: selectedSize,
                    };
                });
                dispatch(setCart({ data: result }));
                dispatch(setCartProducts({ data: productsData }));
                setCartSidebarData(enrichedCart);
                
                // حساب المجموع الفرعي محلياً بدلاً من الاعتماد على الخادم
                const localSubTotal = calculateLocalSubTotal(enrichedCart);
                dispatch(setCartSubTotal({ data: localSubTotal }));
            } else if (result.message == "No item(s) found in users cart") {
                setCartSidebarData([]);
                dispatch(setCartProducts({ data: [] }));
                dispatch(setCartSubTotal({ data: 0 }));
            }
        } catch (err) {
            console.log(err?.message);
        }
        setisLoader(false);
    };

    const fetchGuestCart = async () => {
        setisLoader(true);
        try {
            // إنشاء مصفوفة من جميع المنتجات بمقاسات مختلفة
            const allCartItems = cart?.guestCart || [];
            
            // إذا كانت السلة فارغة، تأكد من تعيين المجموع الكلي إلى 0
            if (allCartItems.length === 0) {
                setCartSidebarData([]);
                setGuestCartSubTotal(0);
                dispatch(setGuestCartTotal({ data: 0 }));
                setisLoader(false);
                return;
            }
            const variantIds = allCartItems.map((p) => p.product_variant_id);
            const quantities = allCartItems.map((p) => p.qty);
            
            const response = await api.getGuestCart(city?.city?.latitude, city?.city?.longitude, variantIds?.join(","), quantities?.join(","));
            const result = await response.json();
            if (result.status == 1) {
                // إنشاء مصفوفة من جميع المنتجات بمقاسات مختلفة
                const enrichedCart = [];
                
                // لكل منتج في guestCart، إنشاء عنصر منفصل
                allCartItems.forEach((cartItem) => {
                    // البحث عن البيانات المقابلة من API
                    const apiItem = result.data.cart.find(item => 
                        item.product_variant_id === cartItem.product_variant_id &&
                        item.product_id === cartItem.product_id
                    );
                    
                    if (apiItem) {
                        // دمج بيانات API مع بيانات السلة المحلية
                        const enrichedItem = {
                            ...apiItem,
                            qty: cartItem.qty,
                            selected_color: cartItem.selected_color || null,
                            selected_size: cartItem.selected_size || null,
                        };
                        
                        enrichedCart.push(enrichedItem);
                    }
                });
                
                setCartSidebarData(enrichedCart);
                
                // حساب المجموع الفرعي محلياً بدلاً من الاعتماد على الخادم
                const localSubTotal = calculateLocalSubTotal(enrichedCart);
                setGuestCartSubTotal(localSubTotal);
                dispatch(setGuestCartTotal({ data: localSubTotal }));
            } else {
                // إذا لم تكن هناك بيانات، تأكد من تعيين المجموع الكلي إلى 0
                setCartSidebarData([]);
                setGuestCartSubTotal(0);
                dispatch(setGuestCartTotal({ data: 0 }));
            }
        } catch (e) {
            console.log(e?.message);
            // في حالة الخطأ، تأكد من تعيين المجموع الكلي إلى 0
            setCartSidebarData([]);
            setGuestCartSubTotal(0);
            dispatch(setGuestCartTotal({ data: 0 }));
        }
        setisLoader(false);
    };

    // دالة لحساب المجموع الفرعي محلياً مع التحقق من تاريخ انتهاء الخصم
    const calculateLocalSubTotal = (products) => {
        if (!products || products.length === 0) {
            // إذا كانت السلة فارغة، تأكد من تعيين المجموع الكلي إلى 0
            setGuestCartSubTotal(0);
            dispatch(setGuestCartTotal({ data: 0 }));
            return 0;
        }
        
        return products.reduce((total, product) => {
            const now = new Date();
            
            // التحقق من وجود بيانات الخصم
            let isDiscountActive = false;
            
            // إذا كان هناك سعر مخصوم وأقل من السعر الأصلي
            if (product?.discounted_price && 
                product?.discounted_price !== 0 && 
                product?.discounted_price < product?.price) {
                
                // إذا كان هناك تواريخ خصم، تحقق منها
                if (product?.discount_start_date && product?.discount_end_date) {
                    const startDate = new Date(product.discount_start_date);
                    const endDate = new Date(product.discount_end_date);
                    isDiscountActive = now >= startDate && now <= endDate;
                } else {
                    // إذا لم تكن هناك تواريخ خصم، استخدم السعر المخصوم دائماً
                    isDiscountActive = true;
                }
            }
            
            const price = isDiscountActive ? product.discounted_price : product.price;
            
            return total + (price * product.qty);
        }, 0);
    };

    //Add to Cart
    const addtoCart = async (product_id, product_variant_id, qty, selectedColor, selectedSize) => {
        await api.addToCart(user?.jwtToken, product_id, product_variant_id, qty, selectedColor, selectedSize)
            .then(response => response.json())
            .then(async (result) => {
                if (result.status === 1) {
                    // toast.success(result.message);
                    // إنشاء مفتاح فريد للمنتج
                    const productKey = `${product_id}_${product_variant_id}_${selectedColor || 'no-color'}_${selectedSize || 'no-size'}`;
                    
                    const updatedCartProducts = cartSidebarData?.map(product => {
                        const cartProductKey = `${product?.product_id}_${product?.product_variant_id}_${product?.selected_color || 'no-color'}_${product?.selected_size || 'no-size'}`;
                        if (cartProductKey === productKey) {
                            return { ...product, qty: qty };
                        } else {
                            return product;
                        }
                    });
                    setCartSidebarData(updatedCartProducts);
                    const updatedProducts = cart?.cartProducts?.map((product) => {
                        const cartProductKey = `${product?.product_id}_${product?.product_variant_id}_${product?.selected_color || 'no-color'}_${product?.selected_size || 'no-size'}`;
                        if (cartProductKey === productKey) {
                            return { ...product, qty: qty };
                        } else {
                            return product;
                        }
                    });
                    dispatch(setCartProducts({ data: updatedProducts }));
                    
                    // حساب المجموع الفرعي محلياً بدلاً من الاعتماد على الخادم
                    const localSubTotal = calculateLocalSubTotal(updatedCartProducts);
                    dispatch(setCartSubTotal({ data: localSubTotal }));

                } else if (result.status === 0) {
                    setisLoader(false);
                }
                else {
                    setisLoader(false);
                    toast.error(result.message);
                }
            });
    };

    //remove from Cart
    const removefromCart = async (product_id, product_variant_id, selectedColor, selectedSize) => {
        // setisLoader(true);
        
        await api.removeFromCart(user?.jwtToken, product_id, product_variant_id, selectedColor, selectedSize)
            .then(response => response.json())
            .then(async (result) => {
                if (result.status === 1) {
                    // toast.success(result.message);
                    // إنشاء مفتاح فريد للمنتج
                    const productKey = `${product_id}_${product_variant_id}_${selectedColor || 'no-color'}_${selectedSize || 'no-size'}`;
                    
                    const updatedCartProducts = cart?.cartProducts?.filter(product => {
                        // حذف المنتج المحدد فقط (نفس product_id, product_variant_id, selected_color, selected_size)
                        const cartProductKey = `${product?.product_id}_${product?.product_variant_id}_${product?.selected_color || 'no-color'}_${product?.selected_size || 'no-size'}`;
                        return cartProductKey !== productKey;
                    });
                    dispatch(setCartProducts({ data: updatedCartProducts ? updatedCartProducts : [] }));
                    
                    const updatedProducts = cartSidebarData?.filter(product => {
                        // حذف المنتج المحدد فقط (نفس product_id, product_variant_id, selected_color, selected_size)
                        const cartProductKey = `${product?.product_id}_${product?.product_variant_id}_${product?.selected_color || 'no-color'}_${product?.selected_size || 'no-size'}`;
                        return cartProductKey !== productKey;
                    });
                    setCartSidebarData(updatedProducts);
                    
                    // حساب المجموع الفرعي محلياً بدلاً من الاعتماد على الخادم
                    const localSubTotal = calculateLocalSubTotal(updatedProducts);
                    dispatch(setCartSubTotal({ data: localSubTotal }));
                }
                else {
                    toast.error(result.message);
                }
            })
            .catch(error => console.log(error));
        // setisLoader(false);
    };
    const { t } = useTranslation();
    const placeHolderImage = (e) => {

        e.target.src = setting.setting?.web_logo;

    };

    const stockValidation = () => {
        cart.cart?.data?.cart.forEach(element => {
            if (!element.status) {
                return () => {
                    toast.error(t('some_items_are_out_of_stock'));
                };
            }
            closeCanvas.current.click();
            navigate('/checkout');
        });
    };

    const removeCoupon = () => {
        dispatch(clearCartPromo());
        toast.info("Coupon Removed");
    };

    function getProductQuantities(products) {
        if (!products || !Array.isArray(products) || products.length === 0) {
            return [];
        }
        return Object.entries(products.reduce((quantities, product) => {
            if (!product || !product.product_id) {
                return quantities;
            }
            // إنشاء مفتاح فريد يتضمن product_id و product_variant_id و اللون والمقاس
            const uniqueKey = `${product.product_id}_${product.product_variant_id}_${product.selected_color || 'no-color'}_${product.selected_size || 'no-size'}`;
            const existingQty = quantities[uniqueKey] || 0;
            return { ...quantities, [uniqueKey]: existingQty + (product.qty || 0) };
        }, {})).map(([uniqueKey, qty]) => {
            const parts = uniqueKey.split('_');
            const productId = parts[0];
            const variantId = parts[1];
            const color = parts[2];
            const size = parts[3];
            return {
                product_id: parseInt(productId),
                product_variant_id: parseInt(variantId),
                selected_color: color === 'no-color' ? null : color,
                selected_size: size === 'no-size' ? null : size,
                qty
            };
        });
    }

    const AddToGuestCart = (productId, productVariantId, Qty, isExisting, selectedColor, selectedSize) => {
        if (isExisting) {
            
            // إنشاء مفتاح فريد للمنتج
            const productKey = `${productId}_${productVariantId}_${selectedColor || 'no-color'}_${selectedSize || 'no-size'}`;
            
            const updatedProducts = cart?.guestCart?.map((cartProduct) => {
                const cartProductKey = `${cartProduct?.product_id}_${cartProduct?.product_variant_id}_${cartProduct?.selected_color || 'no-color'}_${cartProduct?.selected_size || 'no-size'}`;
                if (cartProductKey === productKey) {
                    return { ...cartProduct, qty: Qty };
                } else {
                    return cartProduct;
                }
            }).filter(product => product?.qty !== 0);
            
            const updatedCartProducts = cartSidebarData?.map(cartProduct => {
                const cartProductKey = `${cartProduct?.product_id}_${cartProduct?.product_variant_id}_${cartProduct?.selected_color || 'no-color'}_${cartProduct?.selected_size || 'no-size'}`;
                if (cartProductKey === productKey) {
                    return { ...cartProduct, qty: Qty };
                } else {
                    return cartProduct;
                }
            }).filter(product => product?.qty !== 0);

            if (updatedCartProducts.length === 0) {
                // إذا أصبحت السلة فارغة
                setCartSidebarData([]);
                setGuestCartSubTotal(0);
                dispatch(setGuestCartTotal({ data: 0 }));
            } else {
                computeSubTotal(updatedCartProducts);
                setCartSidebarData(updatedCartProducts);
            }

            dispatch(addtoGuestCart({ data: updatedProducts }));
        } else {
            
            // البحث عن المنتج الحالي للحصول على البيانات الإضافية
            const currentProduct = cartSidebarData?.find(p => 
                p.product_id === productId && 
                p.product_variant_id === productVariantId
            );
            
            const productData = { 
                product_id: productId, 
                product_variant_id: productVariantId, 
                qty: Qty,
                selected_color: selectedColor,
                selected_size: selectedSize
            };
            dispatch(addtoGuestCart({ data: [...cart?.guestCart, productData] }));
            
            // تحديث cartSidebarData والمجموع الكلي عند إضافة منتج جديد
            const newCartData = [...cartSidebarData, { ...currentProduct, qty: Qty, selected_color: selectedColor, selected_size: selectedSize }];
            setCartSidebarData(newCartData);
            computeSubTotal(newCartData);
        }
    };

    const computeSubTotal = (products) => {
        // إذا كانت السلة فارغة، تأكد من تعيين المجموع الكلي إلى 0
        if (!products || products.length === 0) {
            setGuestCartSubTotal(0);
            dispatch(setGuestCartTotal({ data: 0 }));
            return;
        }
        
        const subTotal = products.reduce((prev, curr) => {
            const now = new Date();
            
            // التحقق من وجود بيانات الخصم
            let isDiscountActive = false;
            
            // إذا كان هناك سعر مخصوم وأقل من السعر الأصلي
            if (curr?.discounted_price && 
                curr?.discounted_price !== 0 && 
                curr?.discounted_price < curr?.price) {
                
                // إذا كان هناك تواريخ خصم، تحقق منها
                if (curr?.discount_start_date && curr?.discount_end_date) {
                    const startDate = new Date(curr.discount_start_date);
                    const endDate = new Date(curr.discount_end_date);
                    isDiscountActive = now >= startDate && now <= endDate;
                } else {
                    // إذا لم تكن هناك تواريخ خصم، استخدم السعر المخصوم دائماً
                    isDiscountActive = true;
                }
            }
            
            const price = isDiscountActive ? curr.discounted_price : curr.price;
            prev += price * curr.qty;
            return prev;
        }, 0);
        
        // تحديث كلا المتغيرين لضمان التزامن
        setGuestCartSubTotal(subTotal);
        dispatch(setGuestCartTotal({ data: subTotal }));
    };

    const RemoveFromGuestCart = (productVariantId, selectedColor, selectedSize) => {
        
        // إنشاء مفتاح فريد للمنتج
        const productKey = `${productVariantId}_${selectedColor || 'no-color'}_${selectedSize || 'no-size'}`;
        
        const updatedProducts = cart?.guestCart?.filter((p) => {
            const cartProductKey = `${p?.product_variant_id}_${p?.selected_color || 'no-color'}_${p?.selected_size || 'no-size'}`;
            return cartProductKey !== productKey;
        });
        
        const updatedSideBarProducts = cartSidebarData.filter((p) => {
            const cartProductKey = `${p?.product_variant_id}_${p?.selected_color || 'no-color'}_${p?.selected_size || 'no-size'}`;
            return cartProductKey !== productKey;
        });
        
        if (updatedSideBarProducts.length === 0) {
            // إذا أصبحت السلة فارغة
            setCartSidebarData([]);
            setGuestCartSubTotal(0);
            dispatch(setGuestCartTotal({ data: 0 }));
        } else {
            computeSubTotal(updatedSideBarProducts);
            setCartSidebarData(updatedSideBarProducts);
        }
        
        dispatch(addtoGuestCart({ data: updatedProducts }));
    };

    const handleValidateAddExistingGuestProduct = (productQuantity, product, quantity) => {
        // البحث عن المنتج المحدد باللون والمقاس في السلة
        const selectedColor = product?.selected_color || null;
        const selectedSize = product?.selected_size || null;
        
        // إنشاء مفتاح فريد للمنتج
        const productKey = `${product?.product_id}_${product?.product_variant_id}_${selectedColor || 'no-color'}_${selectedSize || 'no-size'}`;
        
        // البحث عن المنتج المحدد في السلة
        const existingProduct = productQuantity?.find(p => {
            const cartProductKey = `${p?.product_id}_${p?.product_variant_id}_${p?.selected_color || 'no-color'}_${p?.selected_size || 'no-size'}`;
            return cartProductKey === productKey;
        });
        
        if (Number(product.is_unlimited_stock)) {
            if (existingProduct?.qty >= Number(product?.total_allowed_quantity)) {
                toast.error(t("max_cart_limit_error"));
            }
            else {
                AddToGuestCart(product?.product_id, product?.product_variant_id, quantity, 1, selectedColor, selectedSize);
            }
        }
        else {
            if (existingProduct?.qty >= Number(product?.total_allowed_quantity)) {
                toast.error(t("max_cart_limit_error"));
            }
            else if (existingProduct?.qty >= Number(product?.stock)) {
                toast.error(t("limited_product_stock_error"));
            }
            else {
                AddToGuestCart(product?.product_id, product?.product_variant_id, quantity, 1, selectedColor, selectedSize);
            }
        }
    };


    const handleCloseCartSidebar = () => {
        dispatch(setPromoCode({
            code: null,
            discount: 0,
            isPromoCode: false
        }));
        setIsCartSidebarOpen(false)
    }


    return (
        <div tabIndex="-1" className={`cart-sidebar-container offcanvas offcanvas-end ${isCartSidebarOpen ? "show" : ""}`} id="cartoffcanvasExample" aria-labelledby="cartoffcanvasExampleLabel">
            <div className='cart-sidebar-header'>
                <h5>{t("your_cart")}</h5>
                <button type="button" className="close-canvas" data-bs-dismiss="offcanvas" aria-label="Close" ref={closeCanvas} onClick={() => handleCloseCartSidebar()}>
                    <AiOutlineCloseCircle fill='black' />
                </button>
            </div>

            {(cartSidebarData?.length == 0 && !isLoader) ? (
                <div className='empty-cart'>
                    <img src={EmptyCart} alt='empty-cart' onError={placeHolderImage}></img>
                    <p>{t("empty_cart_list_message")}</p>
                    <span>{t("empty_cart_list_description")}</span>
                    <button type='button' className="close-canvas" data-bs-dismiss="offcanvas" aria-label="Close" onClick={() => {
                        navigate('/products');
                        setIsCartSidebarOpen(false)
                    }}>{t("empty_cart_list_button_name")}</button>
                </div>) : (
                <>
                    {isLoader == true
                        ? (
                            <Loader width='100%' height='100%' />
                        )
                        : (
                            <>
                                <div className='cart-sidebar-product'>
                                    <div className='products-header'>
                                        <span>{t("product")}</span>
                                        <span>{t("price")}</span>
                                    </div>

                                    <div className='products-container'>


                                    {cartSidebarData?.map((item, index) => {
                                        // Derive selected color/size information
                                        const selectedColor = item.selected_color || null;
                                        const selectedSize = item.selected_size || null;
                                        
                                        // إنشاء مفتاح فريد للمنتج
                                        const productKey = `${item.product_id}_${item.product_variant_id}_${selectedColor || 'no-color'}_${selectedSize || 'no-size'}`;
                                        
                                        const sourceProduct = cart?.isGuest
                                            ? cart?.guestCart?.find(p => {
                                                const cartProductKey = `${p?.product_id}_${p?.product_variant_id}_${p?.selected_color || 'no-color'}_${p?.selected_size || 'no-size'}`;
                                                return cartProductKey === productKey;
                                            })
                                            : cart?.cartProducts?.find(p => {
                                                const cartProductKey = `${p?.product_id}_${p?.product_variant_id}_${p?.selected_color || 'no-color'}_${p?.selected_size || 'no-size'}`;
                                                return cartProductKey === productKey;
                                            });

                                        return (
                                        <div className="cart-item" key={index}>
                                            <div className="cart-item-image">
                                                <img src={item.image_url} alt={item.name} onError={placeHolderImage} />
                                            </div>
                                            <div className="cart-item-details">
                                                <div className="cart-item-name">
                                                    {item.name}
                                                        </div>
                                                 
                                                {/* Variant Details */}
                                                {(selectedColor || selectedSize) && (
                                                    <div className="cart-item-variant-details">
                                                        {selectedColor && (
                                                            <div className="cart-item-color">
                                                                <span>{t("color")}:</span>
                                                                <div 
                                                                    className="cart-item-color-swatch" 
                                                                    style={{ backgroundColor: selectedColor }}
                                                                    title={selectedColor}
                                                                />
                                                        </div>
                                                        )}
                                                        {selectedSize && (
                                                            <div className="cart-item-size">
                                                                <span>{t("size")}:</span>
                                                                <span>{selectedSize}</span>
                                                        </div>
                                                        )}
                                                    </div>
                                                )}

                                                <div className="cart-item-price">
                                                    {(() => {
                                                        const now = new Date();
                                                        const startDate = item?.discount_start_date ? new Date(item.discount_start_date) : null;
                                                        const endDate = item?.discount_end_date ? new Date(item.discount_end_date) : null;
                                                        const isDiscountActive = item?.discounted_price && 
                                                                               item?.discounted_price !== 0 && 
                                                                               item?.discounted_price < item?.price &&
                                                                               (startDate && endDate ? (now >= startDate && now <= endDate) : true);

                                                        if (isDiscountActive) {
                                                            return (
                                                                <>
                                                                    <span className="current-price price-saudi">
                                                                        {setting.setting?.currency_symbol}
                                                                        {(item.discounted_price * item.qty).toFixed(2)}
                                                                    </span>
                                                                    <span className="original-price price-saudi">
                                                                        {setting.setting?.currency_symbol}
                                                                        {(item.price * item.qty).toFixed(2)}
                                                                    </span>
                                                                </>
                                                            );
                                                        } else {
                                                            return (
                                                                <span className="current-price price-saudi">
                                                                    {setting.setting?.currency_symbol}
                                                                    {(item.price * item.qty).toFixed(2)}
                                                                </span>
                                                            );
                                                        }
                                                    })()}
                                                </div>

                                                <div className="cart-item-quantity">
                                                    <button
                                                        onClick={() => {
                                                            if (cart?.isGuest) {
                                                                if (item.qty > 1) {
                                                                    // Reduce quantity by 1
                                                                    AddToGuestCart(item.product_id, item.product_variant_id, item.qty - 1, true, item.selected_color, item.selected_size);
                                                                } else {
                                                                    // Quantity is 1 – remove the item entirely
                                                                    RemoveFromGuestCart(item.product_variant_id, item.selected_color, item.selected_size);
                                                                }
                                                            } else {
                                                                if (item.qty > 1) {
                                                                    addtoCart(item.product_id, item.product_variant_id, item.qty - 1, item.selected_color, item.selected_size);
                                                                } else {
                                                                    // Quantity is 1 – remove from server cart
                                                                    removefromCart(item.product_id, item.product_variant_id, item.selected_color, item.selected_size);
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        <BiMinus />
                                                    </button>
                                                    <span>{item.qty}</span>
                                                    <button
                                                        onClick={() => {
                                                            if (cart?.isGuest) {
                                                                const productQuantity = getProductQuantities(cart?.guestCart);
                                                                handleValidateAddExistingGuestProduct(productQuantity, item, item.qty + 1);
                                                            } else {
                                                                const productQuantity = getProductQuantities(cart?.cartProducts);
                                                                if (item.is_unlimited_stock) {
                                                                    if (productQuantity?.find(p => p?.product_id === item?.product_id && 
                                                                                                   p?.product_variant_id === item?.product_variant_id &&
                                                                                                   p?.selected_color === item?.selected_color &&
                                                                                                   p?.selected_size === item?.selected_size)?.qty < item?.total_allowed_quantity) {
                                                                        addtoCart(item.product_id, item.product_variant_id, item.qty + 1, item.selected_color, item.selected_size);
                                                                    } else {
                                                                        toast.error(t("max_cart_limit_error"));
                                                                    }
                                                                } else {
                                                                    if (item.qty >= item.stock) {
                                                                        toast.error(t("out_of_stock_message"));
                                                                    } else if (productQuantity?.find(p => p?.product_id === item?.product_id && 
                                                                                                         p?.product_variant_id === item?.product_variant_id &&
                                                                                                         p?.selected_color === item?.selected_color &&
                                                                                                         p?.selected_size === item?.selected_size)?.qty >= item?.total_allowed_quantity) {
                                                                        toast.error(t("max_cart_limit_error"));
                                                                    } else {
                                                                        addtoCart(item.product_id, item.product_variant_id, item.qty + 1, item.selected_color, item.selected_size);
                                                                    }
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        <BsPlus />
                                                    </button>
                                                </div>

                                                <button
                                                    className="cart-item-remove"
                                                    onClick={() => {
                                                        if (cart?.isGuest) {
                                                            RemoveFromGuestCart(item, item.product_variant_id, item.selected_color, item.selected_size);
                                                        } else {
                                                            removefromCart(item.product_id, item.product_variant_id, item.selected_color, item.selected_size);
                                                        }
                                                    }}
                                                >
                                                    <AiOutlineCloseCircle />
                                                </button>
                                            </div>
                                        </div>
                                        )})}


                                    </div>
                                </div>

                                <div className='cart-sidebar-footer'>

                                    {/* Apply Promo Code */}
                                    {cart?.isGuest === false ? <div className="promo-wrapper">
                                        <div className="promo-container">
                                            <div className=" d-flex justify-content-between align-items-center d-lg-flex pb-4 mb-4" style={{ borderBottom: '1px solid lightgrey' }}>
                                                <span className=""
                                                    style={{ fontSize: "16px" }}>{t("have_coupon")}</span>
                                                <button className="btn promo-button" onClick={() => setShowPromoOffcanvas(true)}
                                                // style={{ backgroundColor: '#33a36b', color: 'white', fontSize: '14px' }}
                                                >{t("view_coupon")}</button>
                                            </div>
                                            {cart.cart && cart.promo_code ?
                                                <>
                                                    <div className="promo-code">
                                                        <div className="">
                                                            <span><RiCoupon2Fill size={26} fill='var(--secondary-color)' /></span>
                                                        </div>
                                                        <div className="d-flex flex-column">
                                                            <span className='promo-name'>{cart.promo_code.promo_code}</span>
                                                            <span className='promo-discount-amount'>{cart.promo_code.message}</span>
                                                        </div>
                                                        <div className="d-flex flex-column">
                                                            <span className='price-saudi'> {cart.promo_code.discount}</span>
                                                            <span className='promo-remove' onClick={removeCoupon}> {t("remove")}</span>
                                                        </div>
                                                    </div>
                                                </>
                                                : <></>}
                                        </div>
                                    </div> : null}
                                    <Promo show={showPromoOffcanvas} setShow={setShowPromoOffcanvas} />
                                    {cart.cart?.data === null
                                        ? (
                                            <Loader />
                                        )
                                        : (
                                            <>
                                                <div className='summary'>
                                                    <div className='d-flex justify-content-between'>
                                                        <span>{t("sub_total")}</span>
                                                        <div className='d-flex align-items-center price-saudi flex-row-reverse' style={{ fontSize: "14px" }}>
                                                            
                                                            <span>{cart?.isGuest === false ?
                                                                (cart?.promo_code?.discount ?
                                                                    (cart?.cartSubTotal - cart?.promo_code?.discount)?.toFixed(setting.setting?.decimal_point)
                                                                    :
                                                                    (cart?.cartSubTotal?.toFixed(setting.setting?.decimal_point))

                                                                ) : (guestCartSubTotal || cart?.guestCartTotal || 0)?.toFixed(setting?.setting?.decimal_point)}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='button-container'>
                                                    <button type='button' className='view-cart' onClick={() => {
                                                        closeCanvas.current.click();
                                                        navigate('/cart');
                                                    }}>{t("view_cart")}</button>
                                                    <button type='button' className='checkout' onClick={() => {
                                                        if (cart?.isGuest) {
                                                            setShowModal(true)
                                                            // toast.error(t("login_to_access_checkout_page"));
                                                            closeCanvas.current.click();
                                                        } else {
                                                            stockValidation();
                                                        }

                                                    }}>{cart?.isGuest ? t("login_to_checkout") : t("proceed_to_checkout")}</button>
                                                </div>
                                            </>)}
                                </div>
                            </>
                        )}
                </>
            )
            }
            <Login show={showModal} setShow={setShowModal} />
        </div>
    );
};

export default Cart;

/*
 * التحديثات المضافة في صفحة Cart Sidebar:
 * 
 * 1. إصلاح حساب الخصم في دالة calculateLocalSubTotal:
 *    - تم إزالة المتغير USE_DISCOUNT_WITHOUT_DATES
 *    - تم تعديل منطق التحقق من الخصم ليطبق الخصم دائماً إذا لم تكن هناك تواريخ محددة
 *    - إذا كانت هناك تواريخ خصم، يتم التحقق من أن التاريخ الحالي ضمن نطاق الخصم
 * 
 * 2. إصلاح حساب الخصم في دالة computeSubTotal:
 *    - نفس الإصلاحات المطبقة على calculateLocalSubTotal
 * 
 * 3. إصلاح عرض الأسعار في واجهة المستخدم:
 *    - تم تعديل منطق isDiscountActive ليطبق الخصم حتى لو لم تكن هناك تواريخ محددة
 *    - الآن يتم عرض السعر المخصوم إذا كان متوفراً وأقل من السعر الأصلي
 * 
 * ✅ تم إصلاح مشكلة عدم احتساب الخصم في Cart Sidebar بنجاح!
 */